module.exports = __webpack_public_path__ + "static/media/all-dubstep.6f56e4e3.mp3";